<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
    <mapfre-card [singleCard]="false" [additionalClasses]="'billing-discount-success fs-16'">
        <section class="text-center mb-4">
            <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
                <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
            </ng-container>
            <ng-template #acmicCloseIcon>
                <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
            </ng-template>
            <h5 class="mt-3 fs-24 col-2d373d title-copy" *ngIf="discountName">{{"Thanks for submitting your" | translate}} {{discountName}} {{"request"}}
            </h5>
            <div class="blue-msg-box">
                <div class="icon-section">
                    <img src="./assets/img/images/blue-info-icon.svg" class="blue-info-icon" alt="">
                </div>
                <div class="msg-section">
                    <div class="lineone">
                        All discount requests are subject to review prior to approval.
                    </div>
                    <div class="secondline">
                        An approved discount may not reduce your current amount due and may be applied to the policy
                        balance. If a refund is due to you, and approved, it will be issued in 5 business days.
                    </div>
                </div>
            </div>

            <div class="mb-3 mt-4">
                {{ 'We will reply within 2 business days and reach out if we have any
                questions.' | translate }}
            </div>
            <div>
                {{ 'A copy has been sent to your email:' | translate}}
                <br>
                <strong>
                    {{emailAddress}}
                </strong>
            </div>
        </section>

        <div class="row text-center">
            <div class="col billing-request-btn">
                <mapfre-button [additionalClasses]="'basic primary large-btn waves-effect'"
                    [iconClasses]="'align-middle'"
                    [routerLink]="['/billing-new/'+ policy?.policynumber?.policyNumber +'/details']"> {{ 'CLOSE' |
                    translate }}
                </mapfre-button>
            </div>
        </div>
    </mapfre-card>
</ng-container>